export const useHandleError = (
  onUnhandleRejectionError: (event: PromiseRejectionEvent) => void
) => {
  window.addEventListener("unhandledrejection", async (event) => {
    onUnhandleRejectionError(event);
  });
};
